import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=2f6985da&scoped=true&"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=2f6985da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6985da",
  null
  
)

export default component.exports